// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"ln-z","itemsContainer":"mn-z"};